/**
 * NYP Product Page — Gallery, Lightbox & Interactions
 * Reads image data from window.NYPProductImages (set inline by the Liquid section)
 */
document.addEventListener('DOMContentLoaded', function () {

  /* ── Image data from Liquid ─────────────────────────── */
  const images = window.NYPProductImages || [];
  if (!images.length) return;

  const mainImg    = document.getElementById('mainImg');
  const thumbTrack = document.getElementById('thumbTrack');
  const lightbox   = document.getElementById('lightbox');
  const lbImg      = document.getElementById('lbImg');
  const lbCounter  = document.getElementById('lbCounter');
  const lbThumbsEl = document.getElementById('lbThumbs');
  let currentIdx = 0;

  /* ── Build gallery thumbnails ───────────────────────── */
  images.forEach(function (img, i) {
    var div = document.createElement('div');
    div.className = 'nyp-thumb' + (i === 0 ? ' is-active' : '');
    div.innerHTML = '<img src="' + img.thumb + '" alt="' + img.alt + '" loading="lazy">';
    div.addEventListener('click', function () { selectImage(i); });
    thumbTrack.appendChild(div);
  });

  /* ── Build lightbox thumbnails ──────────────────────── */
  images.forEach(function (img, i) {
    var t = document.createElement('div');
    t.className = 'nyp-lb-thumb' + (i === 0 ? ' is-active' : '');
    t.innerHTML = '<img src="' + img.thumb + '" alt="' + img.alt + '" loading="lazy">';
    t.addEventListener('click', function () { lbGoTo(i); });
    lbThumbsEl.appendChild(t);
  });

  /* ── Select gallery image ───────────────────────────── */
  function selectImage(idx) {
    currentIdx = idx;
    mainImg.src = images[idx].full;
    mainImg.alt = images[idx].alt;
    var thumbEls = document.querySelectorAll('#thumbTrack .nyp-thumb');
    thumbEls.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
    // Scroll thumb track so active thumb stays visible
    if (thumbEls[idx]) {
      var track  = thumbTrack;
      var thumb  = thumbEls[idx];
      var tLeft  = track.scrollLeft;
      var tWidth = track.clientWidth;
      var oLeft  = thumb.offsetLeft;
      var oWidth = thumb.offsetWidth;
      if (oLeft < tLeft) {
        track.scrollTo({ left: oLeft, behavior: 'smooth' });
      } else if (oLeft + oWidth > tLeft + tWidth) {
        track.scrollTo({ left: oLeft + oWidth - tWidth, behavior: 'smooth' });
      }
    }
  }

  /* ── Lightbox ───────────────────────────────────────── */
  function openLightbox(idx) {
    lbGoTo(idx);
    lightbox.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeLightbox() {
    lightbox.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function lbGoTo(idx) {
    currentIdx = (idx + images.length) % images.length;
    lbImg.src  = images[currentIdx].full;
    lbImg.alt  = images[currentIdx].alt;
    lbCounter.textContent = (currentIdx + 1) + ' / ' + images.length;
    document.querySelectorAll('.nyp-lb-thumb')
      .forEach(function (t, i) { t.classList.toggle('is-active', i === currentIdx); });
    selectImage(currentIdx);
  }

  /* ── Gallery arrows ─────────────────────────────────── */
  document.getElementById('galleryPrev').addEventListener('click', function (e) {
    e.stopPropagation();
    selectImage((currentIdx - 1 + images.length) % images.length);
  });
  document.getElementById('galleryNext').addEventListener('click', function (e) {
    e.stopPropagation();
    selectImage((currentIdx + 1) % images.length);
  });

  /* ── Thumbnail row arrows ───────────────────────────── */
  document.getElementById('thumbPrev').addEventListener('click', function () {
    selectImage((currentIdx - 1 + images.length) % images.length);
  });
  document.getElementById('thumbNext').addEventListener('click', function () {
    selectImage((currentIdx + 1) % images.length);
  });

  /* ── Open lightbox on image click ──────────────────── */
  document.getElementById('mainGallery').addEventListener('click', function (e) {
    if (!e.target.closest('.nyp-gallery-arrow')) openLightbox(currentIdx);
  });
  document.getElementById('mainGallery').addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') openLightbox(currentIdx);
  });

  /* ── Lightbox controls ──────────────────────────────── */
  document.getElementById('lbClose').addEventListener('click', closeLightbox);
  document.getElementById('lbBackdrop').addEventListener('click', closeLightbox);
  document.getElementById('lbPrev').addEventListener('click', function (e) {
    e.stopPropagation(); lbGoTo(currentIdx - 1);
  });
  document.getElementById('lbNext').addEventListener('click', function (e) {
    e.stopPropagation(); lbGoTo(currentIdx + 1);
  });

  document.addEventListener('keydown', function (e) {
    if (!lightbox.classList.contains('is-open')) return;
    if (e.key === 'Escape')     closeLightbox();
    if (e.key === 'ArrowLeft')  lbGoTo(currentIdx - 1);
    if (e.key === 'ArrowRight') lbGoTo(currentIdx + 1);
  });

  /* ── Swipe support ──────────────────────────────────── */
  function addSwipe(el, cb) {
    var sx = 0, sy = 0;
    el.addEventListener('touchstart', function (e) {
      sx = e.changedTouches[0].clientX;
      sy = e.changedTouches[0].clientY;
    }, { passive: true });
    el.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - sx;
      var dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) cb(dx < 0 ? 1 : -1);
    }, { passive: true });
  }
  addSwipe(lightbox, function (d) { lbGoTo(currentIdx + d); });
  addSwipe(document.getElementById('mainGallery'), function (d) {
    selectImage((currentIdx + d + images.length) % images.length);
  });

  /* ── Quantity adjuster ──────────────────────────────── */
  var qtyInput = document.getElementById('qtyInput');
  var qtyMinus = document.getElementById('nyp-qty-minus');
  var qtyPlus  = document.getElementById('nyp-qty-plus');
  if (qtyInput && qtyMinus && qtyPlus) {
    if (!qtyInput.value) qtyInput.value = 1;
    qtyMinus.addEventListener('click', function () {
      qtyInput.value = Math.max(1, parseInt(qtyInput.value || 1) - 1);
    });
    qtyPlus.addEventListener('click', function () {
      qtyInput.value = Math.min(99, parseInt(qtyInput.value || 1) + 1);
    });
  }

  /* ── Variant selector — update hidden input & price ── */
  var variantSelect = document.getElementById('nyp-variant-select');
  if (variantSelect && window.NYPVariants) {
    variantSelect.addEventListener('change', function () {
      var variantId = parseInt(this.value);
      var variant = window.NYPVariants.find(function (v) { return v.id === variantId; });
      if (!variant) return;

      // Update hidden id input
      var idInput = document.querySelector('#nyp-product-form input[name="id"]');
      if (idInput) idInput.value = variantId;

      // Update price display
      var priceEl = document.querySelector('.nyp-price');
      var compareEl = document.querySelector('.nyp-compare');
      var saveEl = document.querySelector('.nyp-save');

      if (priceEl) priceEl.textContent = variant.priceFormatted + ' USD';
      if (compareEl && saveEl) {
        if (variant.compareAtPrice && variant.compareAtPrice > variant.price) {
          compareEl.style.display = '';
          saveEl.style.display = '';
          compareEl.textContent = variant.compareAtPriceFormatted;
          saveEl.textContent = 'Save ' + variant.saveFormatted;
        } else {
          if (compareEl) compareEl.style.display = 'none';
          if (saveEl)    saveEl.style.display = 'none';
        }
      }

      // Update ATC button
      var atcBtn = document.querySelector('.nyp-atc');
      if (atcBtn) {
        atcBtn.disabled = !variant.available;
        atcBtn.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }
    });
  }

  /* ── Init ───────────────────────────────────────────── */
  selectImage(0);
  lbCounter.textContent = '1 / ' + images.length;
});

/**
 * ── Sticky Add to Cart bar ─────────────────────────────
 * Deliberately its own listener: the gallery code above bails out early
 * on products with no images, and the sticky bar must still work.
 */
document.addEventListener('DOMContentLoaded', function () {

  var bar = document.getElementById('nypStickyAtc');
  if (!bar) return;

  var mainBtn   = document.querySelector('.nyp-atc');
  var anchor    = document.querySelector('.nyp-atc-row');
  var stickyBtn = document.getElementById('nypStickyBtn');
  if (!mainBtn || !anchor || !stickyBtn) return;

  var priceEl = document.getElementById('nypStickyPrice');
  var labelEl = bar.querySelector('.nyp-sticky-btn-label');
  var baseLabel = bar.getAttribute('data-label') || 'Add to cart';

  document.body.classList.add('nyp-has-sticky-atc');

  /* ── Show / hide ──────────────────────────────────── */
  function setVisible(visible) {
    bar.classList.toggle('is-visible', visible);
    bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
  }

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        // only once the buy button has been scrolled PAST, not before reaching it
        var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        setVisible(scrolledPast);
      });
    }, { threshold: 0 });
    io.observe(anchor);
  } else {
    window.addEventListener('scroll', function () {
      setVisible(anchor.getBoundingClientRect().bottom < 0);
    }, { passive: true });
  }

  /* ── Keep price and availability in step with the main button ── */
  function sync() {
    var soldOut = mainBtn.disabled;
    stickyBtn.disabled = soldOut;
    bar.classList.toggle('is-soldout', soldOut);
    if (labelEl) labelEl.textContent = soldOut ? 'Sold out' : baseLabel;

    var mainPrice = document.querySelector('.nyp-price');
    if (priceEl && mainPrice) {
      priceEl.textContent = mainPrice.textContent.replace(/\s*USD\s*$/i, '').trim();
    }
  }
  sync();

  var variantSelect = document.getElementById('nyp-variant-select');
  if (variantSelect) {
    // runs after the main variant handler has updated price and button state
    variantSelect.addEventListener('change', function () { setTimeout(sync, 0); });
  }

  /* ── Click routes through the real button, so any cart drawer
        or app behaviour attached to the form still applies ── */
  stickyBtn.addEventListener('click', function () {
    if (stickyBtn.disabled) return;
    mainBtn.click();
  });
});
